import React, { forwardRef } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";

const StyleButtonBlue = styled(({ customColor, ...otherProps }) => (
  <Button {...otherProps} />
))(({ variant, customColor }) => ({
  ...(variant === "contained" && {
    borderColor: customColor || "#00bb77",
    color: "#ffffff",
    backgroundColor: customColor || "#00bb77",
    borderRadius: 8,
    "&:hover": {
      borderColor: "#009e67",
      backgroundColor: "#009e67",
    },
  }),
  ...(variant === "contained" &&
    customColor === "error" && {
      borderColor: "red",
      color: "#ffffff",
      backgroundColor: "red",
      borderRadius: 8,
      "&:hover": {
        borderColor: "darkred",
        backgroundColor: "darkred",
      },
    }),
  ...(variant === "outlined" && {
    borderColor: customColor || "#00bb77",
    backgroundColor: "transparent",
    color: customColor || "#00bb77",
    borderRadius: 8,
    "&:hover": {
      borderColor: customColor || "#00bb77",
    },
  }),
  ...(variant === "outlined" &&
    customColor === "secondary" && {
      borderColor: "#DAE2ED",
      color: "#757575",
      backgroundColor: "transparent",
      borderRadius: 8,
      "&:hover": {
        borderColor: "#C7D0DD",
        backgroundColor: "#F3F6F9",
      },
    }),
  ...(variant === "text" && {
    backgroundColor: "transparent",
    color: "#00bb77",
    borderRadius: 8,
    "&:hover": {
      backgroundColor: "#1976d20a",
    },
  }),
  ...(variant === "text" &&
    customColor === "secondary" && {
      backgroundColor: "transparent",
      color: "#212b36",
      borderRadius: 8,
      "&:hover": {
        backgroundColor: "#1976d20a",
      },
    }),
  ...(variant === "contained" &&
    customColor === "warning" && {
      borderColor: "#ffab00",
      color: "#ffffff",
      backgroundColor: "#ffab00",
      borderRadius: 8,
      "&:hover": {
        borderColor: "#b17801",
        backgroundColor: "#b17801",
      },
    }),
}));

const ButtonBlue = forwardRef((props, ref) => {
  return (
    <StyleButtonBlue
      ref={ref}
      type={props.type}
      startIcon={props.startIcon}
      endIcon={props.endIcon}
      style={props.style}
      size={props.size}
      variant={props.variant}
      onClick={props.onClick}
      component={props.component}
      to={props.to}
      className={props.className}
      color={props.color}
      disabled={props.disabled}
      {...props}
    >
      {props.children}
    </StyleButtonBlue>
  );
});

export default ButtonBlue;
